{
    "appTitle": "Cleanfix connect",
    "Imprint": "Impressum",
    "Privacy policy": "Datenschutz",
    "Test environment": "Testumgebung",
    "Your session has expired. Please sign in again.": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
    "Please sign in to continue.": "Bitte melden Sie sich an, um fortzufahren.",
    "settings": {
        "inquiries_new_receive_notifications": "Mich benachrichtigen, wenn eine neue Anfrage eingereicht wird"
    }
}
